<template>
   <footer class="footer">
      <div class="container">
         <div class="footer__row">
            <div class="footer-main">
               <div class="footer__logo">
                  <router-link to="/">
                     <svg width="59" height="67" viewBox="0 0 614 616" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M466.079 57.8035L463.738 44.037L495.335 23.0125L458.564 13.6078L456.25 0L524.998 18.0295L466.079 57.8035Z" fill="#CBF761"/>
                        <path d="M540.969 103.772L475.456 114.867L473.27 102.013L508.849 95.9876L465.48 63.66L531.033 52.5578L533.226 65.4515L497.647 71.4772L540.969 103.772Z" fill="#CBF761"/>
                        <path d="M503.954 157.632L534.683 152.427L532.403 139.018L526.531 139.604L513.285 141.317C508.34 141.42 504.18 140.682 500.803 139.105L503.954 157.632ZM549.669 163.114L506.139 170.486L506.969 175.366L486.337 178.86L484.138 165.927L491.89 164.614L486.345 132.002L478.593 133.315L476.393 120.382L497.025 116.888L498.213 123.87C503.707 127.32 508.19 128.833 511.663 128.408L524.624 126.703L542.965 124.413L549.669 163.114Z" fill="#CBF761"/>
                        <path d="M558.22 212.44L545.38 214.614L541.009 188.906L528.089 191.095L531.368 210.376L518.527 212.55L515.249 193.269L502.329 195.457L506.701 221.165L493.9 223.333L487.343 184.771L551.663 173.878L558.22 212.44Z" fill="#CBF761"/>
                        <path d="M559.006 218.021L562.824 240.476C563.881 246.691 562.594 252.351 558.964 257.456C555.315 262.618 550.39 265.724 544.189 266.774C537.935 267.834 532.285 266.518 527.241 262.829C522.117 259.152 519.031 254.233 517.983 248.07L516.35 238.469L497.11 241.728L494.924 228.874L559.006 218.021ZM542.003 253.92C544.627 253.476 546.731 252.14 548.315 249.913C549.926 247.681 550.509 245.255 550.064 242.637L548.431 233.036L529.111 236.308L530.704 245.916C531.149 248.534 532.488 250.634 534.72 252.215C536.952 253.796 539.379 254.365 542.003 253.92Z" fill="#CBF761"/>
                        <path d="M513.182 334.8L510.841 321.034L542.438 300.009L505.666 290.604L503.353 276.997L572.1 295.026L513.182 334.8Z" fill="#CBF761"/>
                        <path d="M583.842 356.138L523.414 396.413L521.046 382.488L530.05 376.514L526.326 354.614L515.851 351.94L513.49 338.054L583.842 356.138ZM540.556 369.51L553.12 361.382L538.559 357.767L540.556 369.51Z" fill="#CBF761"/>
                        <path d="M598.541 442.341L533.028 453.436L530.843 440.582L566.422 434.557L523.053 402.229L588.606 391.127L590.798 404.021L555.219 410.046L598.541 442.341ZM605.721 415.779C605.982 417.313 606.748 418.53 608.019 419.43C609.321 420.352 610.727 420.686 612.238 420.43L613.25 426.381C610.07 426.919 607.16 426.242 604.52 424.349C601.854 422.461 600.254 419.943 599.719 416.795C599.183 413.648 599.862 410.744 601.754 408.083C603.625 405.454 606.15 403.869 609.33 403.331L610.342 409.282C608.805 409.542 607.586 410.306 606.683 411.575C605.781 412.843 605.461 414.245 605.721 415.779Z" fill="#CBF761"/>
                        <path d="M588.485 513.798C590.096 511.566 590.679 509.141 590.233 506.522L588.601 496.922L560.893 501.614L562.486 511.222C562.931 513.84 564.27 515.94 566.502 517.521C568.733 519.102 572.738 519.404 578.516 518.425C583.578 517.568 586.901 516.025 588.485 513.798ZM558.776 471.851C557.165 474.083 556.583 476.508 557.028 479.126L558.661 488.727L586.368 484.035L584.776 474.427C584.33 471.809 582.992 469.709 580.76 468.128C578.528 466.546 574.881 466.185 569.819 467.042C564.042 468.02 560.361 469.623 558.776 471.851ZM601.355 494.721L602.994 504.361C604.051 510.577 602.764 516.237 599.133 521.341C595.485 526.503 589.341 529.816 580.701 531.279C571.293 532.873 564.067 531.824 559.022 528.135C553.899 524.458 550.813 519.539 549.765 513.376L548.132 503.775L541.851 504.839L539.665 491.985L545.907 490.928L544.267 481.288C543.21 475.072 544.497 469.412 548.128 464.308C551.776 459.146 558.278 455.772 567.633 454.188C576.326 452.716 583.194 453.824 588.239 457.514C593.363 461.191 596.449 466.11 597.497 472.273L599.129 481.873L603.701 481.099L605.887 493.953L601.355 494.721Z" fill="#CBF761"/>
                        <path d="M0 76.6767L21.6523 203.513L94.83 190.184L89.5104 159.02L47.5515 166.662L31.2188 70.9909L0 76.6767Z" fill="#CBF761"/>
                        <path d="M80.5898 61.9989L102.242 188.835L132.8 183.53L111.105 56.4412L80.5898 61.9989Z" fill="#CBF761"/>
                        <path d="M196.801 140.091L174.623 144.13L163.504 79.5458L185.774 75.4889C185.774 75.4889 210.303 73.5073 215.22 103.431C220.137 133.355 196.801 140.091 196.801 140.091ZM245.472 97.4893C235.872 38.6067 178.14 44.2313 178.14 44.2313L125.581 53.8039L147.49 180.854L199.835 171.321C199.835 171.321 255.072 156.371 245.472 97.4893Z" fill="#CBF761"/>
                        <path d="M244.16 32.2076L265.812 159.044L344.084 145.048L338.822 114.224L291.256 122.888L288.1 104.394L330.977 96.5839L325.959 67.1827L283.72 74.876L280.869 58.1694L327.794 49.6235L322.388 17.9597L244.16 32.2076Z" fill="#CBF761"/>
                        <path d="M392.257 66.3553L373.842 69.7086L368.907 41.1611L387.381 37.7963C387.381 37.7963 399.921 36.611 402.054 49.8475C404.186 63.0841 392.257 66.3553 392.257 66.3553ZM418.533 82.5944C418.533 82.5944 436.196 69.5987 432.58 42.876C425.132 -0.75203 381.553 7.18495 381.553 7.18495L332.61 16.0989L354.305 143.187L385.361 137.531L378.399 96.7496L390.283 94.5854L417.946 131.337L452.147 125.107L418.533 82.5944Z" fill="#CBF761"/>
                        <path d="M25.7617 230.341L91.5987 616L263.855 584.628L250.911 508.803L157.036 525.901L104.143 216.065L25.7617 230.341Z" fill="#CBF761"/>
                        <path d="M208.946 262.984L132.387 276.927L121.46 212.913L198.018 198.969L208.946 262.984Z" fill="#CBF761"/>
                        <path d="M135.434 294.766L171.485 505.954L248.045 492.01L211.992 280.823L135.434 294.766Z" fill="#CBF761"/>
                        <path d="M214.9 195.893L280.736 581.552L346.756 569.528L307.274 338.257L483.067 306.241L471.9 240.829L295.234 273.005L292.419 256.516L469.085 224.34L456.711 151.853L214.9 195.893Z" fill="#CBF761"/>
                        <path d="M325.379 350.493L362.288 566.701L522.55 537.513L510.909 469.322L427.205 484.567L424.275 467.403L507.979 452.158L498.138 394.515L415.347 409.594L412.33 391.926L495.122 376.846L485.64 321.305L325.379 350.493Z" fill="#CBF761"/>
                     </svg>
                  </router-link>
               </div>
               <div class="footer-image adaptPc">
                  <img src="@/assets/img/HorizontalLogosV2.svg">
               </div>
               <div class="footer-copy">
                  <div class="footer-copy__rights">{{ copyRightsText }}</div>
               </div>
            </div>
            <div class="footer-progs">
               <div class="footer-progs__title footer__title">
                  Программы
               </div>
               <ul class="footer-progs__list footer__list">
                  <li v-for="list in programms_inf">
                     <router-link :to="'/programms/' + list.slug" class="footer-progs__link footer__link">{{ list.title
                        }}</router-link>
                  </li>
                  <!--                  <li>
                    <a class="footer-progs__link footer__link" href="">Лидер - Шаг вперёд. Лето
                    </a>
                 </li>
                 <li>
                    <a class="footer-progs__link footer__link" href="">Галилео Кидс. Лето</a>
                 </li>
                 <li>
                    <a class="footer-progs__link footer__link" href="">Лидер в Кадре. Лето
                    </a>
                 </li>
                 <li>
                    <a class="footer-progs__link footer__link" href="">
                       Выпускной
                    </a>
                 </li>
                 <li>
                    <a class="footer-progs__link footer__link" href="">Конный лагерь Horse Paradise</a>
                 </li> -->

               </ul>
            </div>
            <div class="footer-about">
               <div class="footer-about__title footer__title">О компании</div>
               <ul class="footer__list footer-about__list">
                  <li>
                     <router-link to="/about" class="footer-about__link footer__link">О нас</router-link>
                  </li>
                  <li>
                     <router-link to="/team" class="footer-about__link footer__link">Команда</router-link>
                  </li>
                  <li>
                     <router-link to="/contact" class="footer-about__link footer__link">Контакты</router-link>
                  </li>
                  <li>
                     <router-link to="/info" class="footer-about__link footer__link">Правовая информация</router-link>
                  </li>
                                   <li>
                    <a class="footer-about__link footer__link" href="/vosp.pdf" target="_blank">Программа воспитательной работы</a>
                 </li>
               </ul>
            </div>
            <div class="footer-contacts">
               <div class="footer__title footer-contacts__title">Контакты</div>
               <ul class="footer__list footer-contacts__list">
                  <li>
                     <a href="tel:+74956496360" class="footer__link footer-contacts__link">+7 (495) 649-63-60</a>
                  </li>
                  <li>
                     <a href="mailto:camp@liderlife.ru" class="footer__link footer-contacts__link">camp@liderlife.ru</a>
                  </li>
                  <li>
                     <a href="https://vk.com/liderlifepub" target="_blank"
                        class="footer__link footer-contacts__link">Вконтакте</a>
                  </li>
                  <li>
                     <a href="https://t.me/liderlifedaily" target="_blank"
                        class="footer__link footer-contacts__link">Телеграм</a>
                  </li>
                  <li>
                     <a href="https://www.youtube.com/user/liderlifevideo" target="_blank"
                        class="footer__link footer-contacts__link">Youtube</a>
                  </li>
                  <li>
                     <a class="footer__link footer-contacts__link cntc">г. Москва, Походный проезд, д. 4, корп. 1 (БЦ
                        Тушино). 4 этаж, офис 409-Б</a>
                  </li>
               </ul>
               <div class="footer-contacts__madeby"><a href="https://oktta.ru" _blank="true" target="_blank" class="link_studio">Сделано в
                     OKTTA</a></div>
               <div class="footer-image adaptMob">
                  <img src="@/assets/img/HorizontalLogosV2.svg">
               </div>
            </div>
         </div>
         <div class="footer-copy">
            <div class="footer-copy__rights">{{ copyRightsText }}</div>
         </div>
      </div>
      <section
         v-bind:class="{ 'hidden': !modalWindowStatus['BackCallModal'], 'fade-in': modalWindowStatus['BackCallModal'] }">
         <BackCallModal :is-active-modal="BackCallModal" @close="closeModal" />
      </section>
   </footer>
</template>

<style scoped>
.footer-copy {
   width: 50%;
}

.adaptPc {
   display: block;
}

.cntc:hover {
   color: #fff !important;
}

.adaptMob {
   display: none;
}

@media (max-width: 1024px) {
   .adaptPc {
      display: none;
   }

   .adaptMob {
      display: block;
   }

   .footer-image {
      max-width: 220px !important;
      margin-top: 20px;
      transform: none !important;
   }
}

.link_studio {
   color: #fff;
}

.footer-image {
   transform: translateY(-50px);
   max-width: 520px;
}

.footer-image img {
   width: 100%;
}
</style>

<script>
import axios from 'axios'
import BackCallModal from '@/components/Modals/BackCallModal'
import { mapActions, mapState } from 'vuex'

const CALLBACK_FORM_DELAY = 20 * 1000;

export default {
   name: 'Footer',
   data() {
      return {
         programms_inf: [],
         timer: null
      }
   },

   components: {
      BackCallModal
   },

   mounted() {
      this.GetSmallInfoProgramms()
      this.showBackCallModal()
   },

   computed: {
      ...mapState({
         modalWindowStatus: state => state.modalWindowStatus,
      }),

      BackCallModal() {
         return this.modalWindowStatus['BackCallModal']
      },

      copyRightsText() {
         let currentYear = new Date().getFullYear()
         return `ООО «ЛидерЛайф Турс» © 2008—${currentYear} Все права защищены`
      }

   },

   methods: {
      ...mapActions([
         'modalStatusSet'
      ]),

      async GetSmallInfoProgramms() {
         await axios
            .get(`/api/v1/small_programms/`)
            .then(response => {
               this.programms_inf = response.data
            })
            .catch(error => {
               console.log(error)
            })
      },

      showBackCallModal() {
         let isWasShowBackCallModal = JSON.parse(localStorage.getItem('isWasShowBackCallModal'))

         if (!isWasShowBackCallModal) {
            this.timer = setTimeout(() => {
               this.modalStatusSet({ modal: 'BackCallModal', status: true });
            }, CALLBACK_FORM_DELAY)
         }
      },
      closeModal() {
         this.modalStatusSet({
            modal: 'BackCallModal',
            status: false,
         })
         localStorage.setItem('isWasShowBackCallModal', true)
      }
   },

   beforeDestroy() {
      console.log(321)
      clearTimeout(this.timer)
   },

}
</script>